const handleShortkeys = (e, dispatch, state) => {
  if ([37, 38, 39, 40].indexOf(e.keyCode) >= 0 && state.selectedElement != null) {
    e.preventDefault()
  }
  switch (e.keyCode) {
    case 37:
      return dispatch({
        type: 'incPosition',
        direction: 'left',
      })
    case 38:
      return dispatch({
        type: 'incPosition',
        direction: 'up',
      })
    case 39:
      return dispatch({
        type: 'incPosition',
        direction: 'right',
      })
    case 40:
      return dispatch({
        type: 'incPosition',
        direction: 'down',
      })

      // case 8:
      //   return dispatch({
      //     type: 'removeSelectedElement',
      //   })

    default:
  }
}

export default handleShortkeys
